interface OrderedDataProps {
  orderData: any;
}

const InvoiceApprovalOrderedData = ({ orderData }: OrderedDataProps) => {
  return (
    <div>
      <div className="mt-10 border mx-[3.75rem] border-[#d0d0d0] p-5 rounded-xl px-10">
        <div className="flex justify-between items-center pb-5">
          <p className="text-lg font-semibold">Mapped Data</p>
        </div>

        <table className="min-w-full border border-gray-200">
          <thead className="w-full bg-gray-100">
            <tr>
              <th className="px-4 py-2 text-sm text-left text-gray-600">S.No</th>    {/* M10-9670 */}
              <th className="px-4 py-2 text-sm text-left text-gray-600">Item Code</th>
              <th className="px-4 py-2 text-sm text-left text-gray-600">Order Code</th>
              <th className="px-4 py-2 text-sm text-left text-gray-600">Item description</th>
              <th className="px-4 py-2 text-sm text-left text-gray-600">Inv. MRP</th>
              <th className="px-4 py-2 text-sm text-left text-gray-600">Inv. PTR</th>
              <th className="px-4 py-2 text-sm text-left text-gray-600">Price</th>
              <th className="px-4 py-2 text-sm text-left text-gray-600">Inv. Qty.</th>
              <th className="px-4 py-2 text-sm text-left text-gray-600">Gross Amt.</th>
              <th className="px-4 py-2 text-sm text-left text-gray-600">Inv. Scheme</th>
              <th className="px-4 py-2 text-sm text-left text-gray-600">Discount %</th>
              <th className="px-4 py-2 text-sm text-left text-gray-600">Cash Discount %</th>
              <th className="px-4 py-2 text-sm text-left text-gray-600">Scheme Qty.</th>
              <th className="px-4 py-2 text-sm text-left text-gray-600">GST % </th>
              <th className="px-4 py-2 text-sm text-left text-gray-600">Batch</th>
            </tr>
          </thead>
          <tbody>
            {orderData?.map((item: any, index: any) => (
              <tr key={index} className={index % 2 === 0 ? "bg-gray-50 text-sm h-12" : "text-sm h-12"}>
                <td className="px-4 py-2 border-t">{index + 1}</td>    {/* M10-9670 */}
                <td className="px-4 py-2 border-t">{item?.item_code}</td>
                <td className="px-4 py-2 border-t">{item?.orderProduct?.order?.order_code}</td>
                <td className="px-4 py-2 border-t">{item?.item_description}</td>
                <td className="px-4 py-2 border-t">{item?.inv_mrp}</td>
                <td className="px-4 py-2 border-t">{item?.ptr}</td>
                <td className="px-4 py-2 border-t">{item?.fixed_price ? item?.fixed_price : item?.ptr}</td>
                <td className="px-4 py-2 border-t">{item?.quantity}</td>
                <td className="px-4 py-2 border-t">{Number(item?.gross_amt).toFixed(2)}</td>
                <td className="px-4 py-2 border-t">{item?.price_identifier}</td>
                <td className="px-4 py-2 border-t">{Number(item?.discount_perc).toFixed(2)}</td>
                <td className="px-4 py-2 border-t">{item?.p_cash_discount_perc || "-"}</td>
                <td className="px-4 py-2 border-t">{item?.free_qty || 0}</td>
                <td className="px-4 py-2 border-t">{item?.p_gst_perc || 0}</td>
                <td className="px-4 py-2 border-t">{item?.batch_no || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default InvoiceApprovalOrderedData;
